@if (isDataLoaded()) {
  <div class="pb-5">
    <div class="ps-1">
      <ng-container [formGroup]="form">
        <rask-input label="Mallnamn" formControlName="namn" placeholder="Ange namn" [required]="true"></rask-input>
      </ng-container>
      <rask-selector class="col-3" label="Produktionsområde" [values]="getProduktionsomraden()" [formatter]="ssItemFormatter" [(ngModel)]="selectedProduktionsOmrade" [viewFormatter]="ssItemViewFormatter" [groupBy]="poGrouper" (change)="produktionsMalChange()"></rask-selector>
      <rask-checkbox text="Visa endast handelssortiment med produktionsmål" (checkedChange)="toggleProduktionsMal($event)"></rask-checkbox>
    </div>
    <div class="ps-3 pe-3">
      <table class="svea-table fkm-table mt-2">
        <thead>
          <tr class="rask-header-row rask-row">
            <th class="fkm-largecell">Handelssortimentsgrupp</th>
            <th>Handelssortiment</th>
            <th class="fkm-mediumcell">Måttslag</th>
            <th class="fkm-tinycell">Grundpris</th>
            <th class="fkm-tinycell">TA</th>
            <th class="fkm-tinycell">FSC</th>
            <th class="fkm-tinycell">PEFC</th>
            <th class="fkm-tinycell">TB</th>
            <th class="fkm-iconcell"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            @for (row of $any(form.controls.handelssortiment).controls; track row) {
              <tr
                class="rask-row fkm-row {{getHSInactiveClass(row)}}"
                [ngbPopover]="inactivePopoverTemplate"
                [closeDelay]="300"
                triggers="mouseenter:mouseleave"
                [disablePopover]="!isInactiveHS(row)">
                <ng-container [formGroup]="row">
                  <td class="svea-input fkm-input-col">
                    @if (hsGroupEditable(row)) {
                      <rask-selector
                        [formatter]="ssItemFormatter"
                        [viewFormatter]="ssItemViewFormatter"
                        placeholder="Välj handelssortimentgrupp"
                        formControlName="handelssortimentsGruppId"
                        [values]="getHSGroups(row)">
                      </rask-selector>
                    }
                    @if (!hsGroupEditable(row)) {
                      <div class="ps-2 pt-1" [ngClass]="{'fw-bold': !getHSValue(row)}">
                        {{ getHSGroupValue(row) }}
                      </div>
                    }
                  </td>
                  <td class="svea-input fkm-input-col">
                    @if (hsEditable(row)) {
                      <rask-selector
                        [formatter]="ssItemFormatter"
                        [viewFormatter]="ssItemViewFormatter"
                        placeholder="Välj handelssortiment"
                        formControlName="handelssortimentId"
                        [values]="getHSList(row)">
                      </rask-selector>
                    }
                    @if (!hsEditable(row)) {
                      <div class="ps-2 pt-1">
                        {{ getHSValue(row) }}
                      </div>
                    }
                  </td>
                  <td class="svea-input fkm-input-col"><rask-selector [formatter]="ssItemFormatter" [viewFormatter]="ssItemViewFormatter" placeholder="Välj måttslag" formControlName="mattslag" [values]="getmattslaglista()"></rask-selector></td>
                  <td class="svea-input fkm-input-col"><rask-input-number formControlName="grundpris"></rask-input-number></td>
                  <td class="svea-input fkm-input-col"><rask-input-number formControlName="tillaggAvdrag"></rask-input-number></td>
                  <td class="svea-input fkm-input-col"><rask-input-number formControlName="fsc"></rask-input-number></td>
                  <td class="svea-input fkm-input-col"><rask-input-number formControlName="pefc"></rask-input-number></td>
                  <td class="svea-input fkm-input-col"><rask-input-number formControlName="tackningsbidrag"></rask-input-number></td>
                  <td class="fkm-input-col bg-white"><rask-icon-button (click)="removeRow(row)" icon="far fa-trash-alt"></rask-icon-button></td>
                </ng-container>
              </tr>
            }
          </ng-container>
        </tbody>
      </table>
    </div>
    <div class="pb-4 pt-2">
      <rask-action-button icon="fas fa-plus" (click)="addRow()" class="float-start">Lägg till rad</rask-action-button>
      <div class="float-end mt-4">
        <rask-button color="secondary" negative (click)="removeMall()">Ta bort</rask-button>
        <rask-button color="secondary" [disabled]="!isDirty()" (click)="saveAll(true)">Spara</rask-button>
      </div>
    </div>
    @if (validationContext) {
      <div class="feedback-panel">
        @for (error of validationContext.errors; track error) {
          <small class="text-danger feedback-item">{{error}}</small>
        }
      </div>
    }
  </div>
}

<ng-template #inactivePopoverTemplate>
  Handelssortimentet är inaktivt
</ng-template>
